import React from 'react'
import RegistrationStatusComponent from '../Components/MHL_Reports/RegistrationStatusComponent'

const RegistrationStatusPage = () => {
  return (
    <div><RegistrationStatusComponent/></div>
  )
}

export default RegistrationStatusPage